// extracted by mini-css-extract-plugin
export default {"container":"Card_container__VaiZR","primary":"Card_primary__soFMl","secondary":"Card_secondary__AOGXI"};